import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c(VOverlay,{attrs:{"absolute":true,"opacity":"0.35"}},[_c('lottie',{attrs:{"options":_vm.lottieOptions,"height":250,"width":250}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }